import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Loading from '../../../../../Loading/Loading';
import LGColumn from '../../../../../card/LearningGrowth/LGColumn/LGColumn';
import LGRow from '../../../../../card/LearningGrowth/LGRow/LGRow';

const LcsData = ({}) => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const mode = useSelector((state) => state?.classMarking?.mode || []);
  const student = useSelector((state) => state?.classMarking?.student);
  const studentLoading = useSelector((state) => state?.classMarking?.studentLoading);
  const loadingLearningGrowth = useSelector((state) => state?.classMarking?.loadingLearningGrowth);
  const learningGrowth = useSelector((state) => state?.classMarking?.learningGrowth);
  const view = useSelector((state) => state?.classMarking?.learningGrowthView);
  const lcsIds = useSelector((state) => state?.classMarking.lcsIds || []);
  const lcs = useSelector((state) => state?.class?.unitOfLearning?.lcs || []);
  const completed = useSelector((state) => state?.classMarking.learningGrowthType);
  const currentMode = mode?.find((item) => item.studentId === student?._id);
  const renderLcs = useCallback(
    (lcs) => {
      return lcs.filter((lc) => (lcsIds.length > 0 ? lcsIds.includes(lc._id) : true));
    },
    [lcsIds]
  );

  return (
    <>
      {(studentLoading || loadingLearningGrowth || currentMode?.mode === 'saving') && (
        <div className='absolute top-0 bottom-0 left-200px right-0 bg-loading z-12'>
          <Loading />
        </div>
      )}
      <div
        className={[
          'absolute top-0 bottom-0 left-200px right-0 overflow-auto',
          student ? '' : 'opacity-90 cursor-not-allowed pointer-events-none'
        ].join(' ')}
      >
        {view === 'column' && (
          <LGColumn
            lcs={renderLcs(student ? student.lcs : lcs)}
            completed={completed}
            currentCurriculum={currentCurriculum}
            learningGrowth={learningGrowth}
            loadingLearningGrowth={loadingLearningGrowth}
          />
        )}
        {view === 'row' && (
          <LGRow
            lcs={renderLcs(student ? student.lcs : lcs)}
            completed={completed}
            currentCurriculum={currentCurriculum}
            learningGrowth={learningGrowth}
            loadingLearningGrowth={loadingLearningGrowth}
            direction={view}
          />
        )}
      </div>
    </>
  );
};

export default LcsData;
